import { Button, Grid, withStyles } from "@material-ui/core";
import ReceivingHours from "./ReceivingHours";
import { useState } from "react";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import { weekday } from "../../../Dispatch/RouteExecution/Pickups/PickupManagement/ShipperInfo/utils";

const styles = (theme) => ({
  weekendContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    display: 'flex',
    alignItems: 'center',
    maxWidth: '158px',
    paddingLeft: '10px',
    borderRadius: '4px',
    float: 'right'
  },
  resetButton: {
    fontSize: theme.textFontSize,
    color: theme.error,
    float: 'right',
    textTransform: 'uppercase'
  },
  toggleText: {
    display: 'inline-block',
    fontSize: theme.textFontSize,
    color: theme.iconColor
  }
});

const daysOrder = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6
};

const getSortedReceivingHoursByDay = (receivingHours) => {
  return Object.entries(receivingHours ?? [])
    .sort(([dayA], [dayB]) => daysOrder[dayA] - daysOrder[dayB])
    .reduce((acc, [day, hours]) => {
      acc[day] = hours;
      return acc;
    }, {});
}

const ReceivingHoursRenderer = ({
  receivingHours,
  updateHours,
  errorInfo,
  resetToDefaultHours,
  activeForm,
  classes,
  defaultHours,
  enableMultipleTimeWindows = true,
}) => {
  const [isWeekendIncluded, setWeekendDelivery] = useState(
    receivingHours.hasOwnProperty(weekday[6])
  );
  const errorFieldName =
    activeForm === "delivery" ? "receivingHours" : "shippingHours";
  const onToggleIncludeWeekend = () => {
    if (isWeekendIncluded) {
      delete receivingHours[weekday[6]];
      delete receivingHours[weekday[7]];
    } else {
      receivingHours[weekday[6]] = defaultHours;
      receivingHours[weekday[7]] = defaultHours;
    }
    setWeekendDelivery(prevState => !prevState)
  }
  const sortedReceivingHours = getSortedReceivingHoursByDay(receivingHours)
  return (
    <div>
      <div className={classes.weekendContainer}>
        <div className={classes.toggleText}>Include weekend</div>
        <ToggleRenderer
          value={isWeekendIncluded}
          onChange={onToggleIncludeWeekend}
        />
      </div>
      <div>
        <Grid container spacing={16}>
          <Grid container item xs={12} spacing={16}>
            {Object.keys(sortedReceivingHours).map((day, index) => (
              <Grid item xs={4} key={day}>
                <ReceivingHours
                  dayName={day}
                  hours={sortedReceivingHours[day]}
                  updateHours={updateHours}
                  errors={errorInfo?.[errorFieldName]?.[day]}
                  dayIndex={index}
                  defaultHours={defaultHours}
                  enableMultipleTimeWindows={enableMultipleTimeWindows}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </div>
      <Grid item xs={12}>
        <Button
          id="resetToDefaultHours"
          onClick={resetToDefaultHours}
          variant="text"
          classes={{
            root: classes.resetButton,
          }}
          up
        >
          Reset Default Hours
        </Button>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(ReceivingHoursRenderer);
